/**
 * app-search — types + validator for the global search-state of `_app` layout.
 *
 * Centralizes in URL overlays mounted at `_app` level (currently: account
 * switcher), so pasting URL reopens exactly the same screen.
 * `validateSearch` omits defaults (does not pollute URL on empty state).
 */

interface AppLayoutSearch {
  /** Account switcher open (`?account=switch`).*/
  account?: "switch";
}

/**
 * Validates + normalizes the layout search. Omits defaults to keep the URL
 * clean. Tolerant: unknown values are discarded (rendering does not break).
 */
export function validateAppLayoutSearch(search: Record<string, unknown>): AppLayoutSearch {
  const out: AppLayoutSearch = {};
  if (search.account === "switch") {
    out.account = "switch";
  }
  return out;
}
